export const NAVIGATE_TO_DASHBOARD = 'NAVIGATE_TO_DASHBOARD';
